import React, { useEffect } from 'react';
import { OutreachContext } from '../lib/OutreachContext';

import Heading from '../../presentational_components/Heading';
import SubText from '../../presentational_components/SubText';
import InputContainer from '../../presentational_components/InputContainer';
import StyledInput from '../../presentational_components/StyledInput';

function Organisation({ onKeyDown }) {
  const { state, dispatch } = React.useContext(OutreachContext);

  const handleChange = (e) => {
    dispatch({ type: 'setUserData', key: 'outreach_organisation', value: e.target.value });
  }

  useEffect(() => {
    dispatch({ type: 'setFormValid', value: state.userData.outreach_organisation.length >= 3 });
  }, [state.userData.outreach_organisation]);

  return (
    <>
      <Heading>What organisation are you working or volunteering for?</Heading>
      <SubText>This helps us keep track of where and how rapid self-test kits are being given out.</SubText>

      <InputContainer>
        <StyledInput
          label='Organisation'
          attributeName='outreach_organisation'
          value={state.userData.outreach_organisation}
          onChange={handleChange}
          formName='outreach'
          autoFocus={true}
          onKeyDown={onKeyDown}
        />
      </InputContainer>
    </>
  );
}

export default Organisation;
